<template>
  <div class="main">
    <div class="body">
      <div class="border">
        <div class="title">专业适合度大排行</div>
        <div class="txt">
          <div v-for="(item, key) in zyranking" :key="key">
            <div style="
                    font-size: 20px;
                    margin-top: 50px;
                    font-weight: bold;
                    margin-bottom: 20px;
                  ">
              {{ item.Class }}专业上的适合度整体排行
            </div>
            <div v-for="(val, k) in item.Subject" :key="k">
              <div>
                <div style="
                        display: inline-block;
                        width: 35%;
                        text-align: right;
                        padding-right: 25px;
                      ">
                  <div v-if="val.Points == 0" style="font-weight: bold">
                    {{ val.Name }}
                  </div>
                  <div v-else>
                    {{ val.Name }}
                  </div>
                </div>
                <div style="display: inline-block; width: 50%" v-if="val.Points != 0">
                  <el-progress :text-inside="true" :stroke-width="20" :format="format1" :percentage="Number(val.Points)"></el-progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["zyranking"],
  name: "",
  
  
  methods: {
    format1(item) {
      return item;
    },
  },
};
</script>


<style scoped lang='less'>
.content {
  max-width: 800px;
  margin: 0 auto;
}
.main {
  .home_page {
    background-image: linear-gradient(#8950d5, #bb85e7);
    color: white;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .body {
    padding: 20px;
  }
  .border {
    padding: 20px;
    padding-bottom: 40px;
    border: 1px solid #c4a7e9;
    position: relative;
    margin-top: 57px;
    .title {
      position: absolute;
      top: -23px;
      left: 276px;
      height: 41px;
      width: 200px;
      background: #c4a7e9;
      text-align: center;
      line-height: 40px;
      color: white;
    }
  }

  .tables {
    border: 1px solid #c4a7e9;
  }

  .line div {
    padding: 6px;
    font-weight: bold;
    background-color: #ffffff;
  }
  .l {
    float: left;
  }
  .r {
    float: right;
    margin-bottom: 0px;
  }
}
.n_title {
  display: inline-block;
  text-indent: 2rem;
  position: relative;
  left: -21px;
  background: #c4a7e9;
  color: white;
  margin-top: 90px;
  margin-bottom: 20px;
  width: 300px;
}
.right {
  display: inline-block;
  width: 400px;
  span {
    width: 20%;
    text-align: center;
    display: inline-block;
  }
}
.txt {
  line-height: 30px;
}
#chart {
  width: 500px;
  height: 500px;
  margin: 100px auto 0;
}
.tables1 {
  margin-top: 10px;
  border-collapse: collapse;
  td {
    border: 1px solid rgb(173, 169, 169);
  }
}
.print {
  position: fixed;
  bottom: 100px;
  right: 200px;
}
</style>
